import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { formatNumber } from 'utils/helper';
import moment from 'moment';
interface IDialogFlightInformationProps {
  flights: any[];
  isShow: boolean;
  onCloseDialog: () => void;
}
interface AirportInfo {
  code?: string;
  name?: string;
  terminal?: string | number;
}
const formatDuration = (duration: string) => {
  const h = Number(duration.slice(0, 2));
  const m = Number(duration.slice(2));

  if (h && m) return `${h}h${m}p`;
  if (h) return `${h}h`;
  return `${m}p`;
};
const DialogFlightInformation: React.FC<
  IDialogFlightInformationProps
> = props => {
  const { flights, isShow, onCloseDialog } = props;
  const translations = useSelector(selectTranslations);
  const formatAirportText = (data?: AirportInfo) => {
    if (!data) return '';
    const parts = [
      data.code,
      data.name,
      data.terminal ? `T${data.terminal}` : '',
    ];
    return parts.filter(Boolean).join(' ');
  };
  return (
    <ModalContainer
      isShow={isShow}
      onCloseDialog={onCloseDialog}
      maskClosable={false}
      modalPadding="16px 24px 32px"
      modalHeight="initial"
      styleSlots={{
        iconWrapperStyle: {
          margin: '0 16px 0 0',
        },
        modalContentStyle: {
          maxWidth: 980,
          width: '96vw',
          maxHeight: '96vh',
        },
        modalBodyStyle: {
          height: 'fit-content',
        },
      }}
      modalProps={{ destroyOnClose: true }}
      CloseIcon={<CloseIcon width={12} height={12} />}
    >
      <TitleModel>
        {translations?.['b2b.txt.flightInformation'] || ''}
      </TitleModel>
      <Line />
      {flights?.map((flight, index) => {
        const trip = flight?.trip || flight;
        const itinerary = trip?.listItinerary[0];
        let selectedPricing = flight?.pricing;
        const aircraft =
          itinerary?.carrier && itinerary?.flightNumber
            ? `${itinerary.carrier}${itinerary?.flightNumber}`
            : itinerary?.carrier || itinerary?.flightNumber || '';
        return (
          <FlightLegCard key={`flight-${index}`}>
            <Header>
              <Title>
                {index === 0
                  ? translations?.['b2b.txt.departureLeg']
                  : translations?.['b2b.txt.returnLeg']}
              </Title>
              <Price>{`+${formatNumber(
                selectedPricing?.paxAdditionalAmount || 0,
                '.',
              )}đ`}</Price>
            </Header>
            <Content>
              <Timeline>
                <span className="dot" />
                <span className="line" />
                <span className="dot" />
              </Timeline>
              <Info>
                <Row>
                  <Time>
                    {moment(itinerary?.departureInfo?.datetime).format('HH:mm')}
                  </Time>
                  <Location>
                    {formatAirportText(itinerary?.departureInfo)}
                  </Location>
                </Row>
                <Meta>
                  <Duration>
                    {formatDuration(itinerary?.duration || '')}
                  </Duration>
                  <Aircraft>{aircraft}</Aircraft>
                </Meta>

                <Row>
                  <Time>
                    {moment(itinerary?.arrivalInfo?.datetime).format('HH:mm')}
                  </Time>
                  <Location>
                    {formatAirportText(itinerary?.arrivalInfo)}
                  </Location>
                </Row>
              </Info>
            </Content>
          </FlightLegCard>
        );
      })}
    </ModalContainer>
  );
};
export default DialogFlightInformation;
const TitleModel = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
const Line = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 16px -24px;
`;
const FlightLegCard = styled.div`
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  font-size: 14px;
  border: 1px solid #e5e5e5;
  margin-bottom: 16px;
`;
const Header = styled.div`
  background: #f5f5f5;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.div`
  font-weight: 500;
`;
const Price = styled.div`
  font-weight: 600;
`;
const Content = styled.div`
  display: flex;
  padding: 14px;
`;
const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  .dot {
    width: 8px;
    height: 8px;
    background: #262626;
    border-radius: 50%;
  }
  .line {
    flex: 1;
    width: 2px;
    background: #ddd;
    margin: 0px 0;
  }
`;
const Info = styled.div`
  flex: 1;
`;
const Row = styled.div`
  display: flex;
  gap: 8px;
`;

const Time = styled.div`
  min-width: 48px;
  font-weight: 600;
`;

const Location = styled.div``;
const Meta = styled.div`
  margin: 4px 0 8px 56px;
  font-size: 12px;
  display: flex;
  gap: 12px;
`;

const Duration = styled.div`
  color: #8d8d8d;
`;

const Aircraft = styled.div`
  color: var(--color-9);
`;
